<template>
  <div id='register-page-container' class='container-fluid page'>
    <div class='row'>
      <div class='col-sm-6 col-md-6 col-lg-6 mx-auto'>
        <div id='card-register' class='card card-signin my-5'>
          <div class='card-body'>
            <h2 class='card-title text-center' style="margin-bottom: 20px;"><span class='icon-user-plus-solid'></span>  Créer votre compte</h2>
            <div class='container'>
              <div style="margin-top: 25px;margin-bottom: 25px;">
                <hr />
              </div>
              <div style="margin-top: 25px;margin-bottom: 25px;">
                Crédicys vous <b>permet d’initier une procédure de recouvrement à l’encontre de votre débiteur</b> pour une créance inférieure ou égale à 5000 euros.
              </div>
              <div style="margin-top: 25px;margin-bottom: 25px;">
                <hr />
              </div>
              <form novalidate action='#' @submit.prevent='register'>
                <h5>Identifiants</h5>
                <div class='form-group row'>
                  <label for='email' class='col-sm-4 col-form-label'>Email <span
                    class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8'>
                    <input type='email' class='form-control' id='email'
                           placeholder='Entrez votre Email'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre Email'" v-model='email'
                           :class="[{'form-control':true, 'is-invalid' : !validEmail(email) && blur_email},{'form-control':true, 'is-valid' : validEmail(email) && blur_email}]"
                           v-on:blur='blur_email = true'/>
                    <div class='invalid-feedback'>
                      {{ error_email }}
                    </div>
                    <div class='valid-feedback'>
                      Email valide.
                    </div>
                  </div>
                </div>
                <div class='form-group row'>
                  <label for='password' class='col-sm-4 col-form-label'>Mot de passe <span
                    class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8 input-group'>
                    <input :type='passwordFieldType' v-model='password' class='form-control'
                           id='password'
                           placeholder='Entrez votre mot de passe'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre mot de passe'"
                           :class="[{'form-control':true, 'is-invalid' : !validPassword(password) && blur_password},{'form-control':true, 'is-valid' : validPassword(password) && blur_password}]"
                           v-on:blur="blur_password = true"/>
                    <div class='input-group-append' @mousedown='showPasswords'
                         @mouseup='hidePasswords'>
                      <span class='input-group-text'><span class='icon-eye'></span></span>
                    </div>
                    <div class='invalid-feedback'>
                      {{ error_password }}
                    </div>
                    <div class='valid-feedback'>
                      Mot de passe valide.
                    </div>
                  </div>
                </div>
                <div class='form-group row'>
                  <label for='password_confirmation' class='col-sm-4 col-form-label'>Confirmation
                    <span
                      class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8 input-group'>
                    <input :type='passwordFieldType' v-model='password_confirmation'
                           class='form-control' id='password_confirmation'
                           placeholder='Confirmez votre mot de passe'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Confirmez votre mot de passe'"
                           :class="[{'form-control':true, 'is-invalid' : !validPasswordConfirmation(password_confirmation) && blur_password_confirmation},{'form-control':true, 'is-valid' : validPasswordConfirmation(password_confirmation) && blur_password_confirmation}]"
                           v-on:blur='blur_password_confirmation = true'/>
                    <div class='input-group-append' @mousedown='showPasswords'
                         @mouseup='hidePasswords'>
                      <span class='input-group-text'><span class='icon-eye'></span></span>
                    </div>
                    <div class='invalid-feedback'>
                      {{ error_password_confirmation }}
                    </div>
                    <div class='valid-feedback'>
                      Mots de passe identiques.
                    </div>
                  </div>
                </div>
                <div style="margin-top: 25px;margin-bottom: 25px;">
                  <hr />
                </div>
                <div class='form-group row'>
                  <div class='col-sm-12'>
                    <h5>Vous êtes ?</h5>
                  </div>
                  <div class='col-sm-6 text-center'>
                    <label><input type='radio'
                                  name='type_person'
                                  value='legal'
                                  v-model='type_person'
                                  checked
                                  @change="onChangeTypePerson()">
                      Une Personne morale
                    </label>
                  </div>
                  <div class='col-sm-6 text-center'>
                    <label><input type='radio'
                                  name='type_person'
                                  value='natural'
                                  v-model='type_person'
                                  @change="onChangeTypePerson()">
                      Une Personne physique
                    </label>
                  </div>
                </div>
                <div style="margin-top: 25px;margin-bottom: 25px;">
                  <hr />
                </div>
                <div style="margin-top: 25px;margin-bottom: 25px;">
                  L'accès à la plateforme Crédicys est accessible aux seules personnes physiques ou morales <b>résidant sur le territoire français et disposant d'un compte bancaire domicilié en France</b>.
                </div>
                <div style="margin-top: 25px;margin-bottom: 25px;">
                  <hr />
                </div>
                <template v-if="type_person === 'legal'">
                  <div class='form-group row'>
                    <label for='company_name' class='col-sm-4 col-form-label'>Raison sociale <span class='icon-asterisk-solid'></span></label>
                    <div class='col-sm-8'>
                      <input type='text' id='company_name' class='form-control' required
                             placeholder='Société' onfocus="this.placeholder=''"
                             onblur="this.placeholder='Société'" v-model='company_name'
                             :class="[{'form-control':true, 'is-invalid' : !validCompanyName(company_name) && blur_company_name},{'form-control':true, 'is-valid' : validCompanyName(company_name) && blur_company_name}]"
                             v-on:blur='blur_company_name = true'/>
                      <div class='invalid-feedback'>
                        {{ error_company_name }}
                      </div>
                      <div class='valid-feedback'>
                        Société valide.
                      </div>
                    </div>
                  </div>
                  <div class='form-group row'>
                    <label for='legal_type_person_title' class='col-sm-4 col-form-label'>Forme juridique <span class='icon-asterisk-solid'></span></label>
                    <div class='col-sm-8'>
                      <select class='custom-select mb-2 mr-sm-2 mb-sm-0'
                              id='legal_type_person_title' name='legal_type_person_title'
                              v-model='legal_type_person_title'>
                        <option value='3' selected>Société Anonyme (SA)</option>
                        <option value='4'>Société à Responsabilité Limitée (SARL)</option>
                        <option value='10'>Entreprise Unipersonnelle à Responsabilité Limitée (EURL)</option>
                        <option value='9'>Société par Actions Simplifiée (SAS)</option>
                        <option value='11'>Société par Actions Simplifiée Unipersonnelle (SASU)</option>
                        <option value='5'>Société en Nom Collectif (SNC)</option>
                        <option value='6'>Société Civile Professionnelle (SCP)</option>
                        <option value='12'>Société d'Exercice Libéral à Responsabilité Limitée (SELARL)</option>
                        <option value='13'>Société d'Exercice Libéral par Actions Simplifiée (SELAS)</option>
                        <option value='14'>Association</option>
                        <option value='8'>Autre</option>
                      </select>
                    </div>
                  </div>
                  <div class='form-group row'>
                    <label for='siret' class='col-sm-4 col-form-label'>SIRET <span class='icon-asterisk-solid'></span></label>
                    <div class='col-sm-8'>
                      <input type='number' id='siret' class='form-control' required
                             placeholder='Siret' onfocus="this.placeholder=''"
                             onblur="this.placeholder='Siret'" v-model='siret'
                             :class="[{'form-control':true, 'is-invalid' : !validSiret(siret) && blur_siret},{'form-control':true, 'is-valid' : validSiret(siret) && blur_siret}]"
                             v-on:blur='blur_siret = true'/>
                      <div class='invalid-feedback'>
                        {{ error_siret }}
                      </div>
                      <div class='valid-feedback'>
                        SIRET valide.
                      </div>
                    </div>
                  </div>
                  <div class='form-group row'>
                    <label for='activity_area' class='col-sm-4 col-form-label'>Secteur d'activité <span class='icon-asterisk-solid'></span></label>
                    <div class='col-sm-8'>
                      <select class='custom-select mb-2 mr-sm-2 mb-sm-0'
                              id='activity_area' name='activity_area'
                              v-model='selected_activity_area'>
                        <option v-for='activity_area in activity_area_list'
                                v-bind:value='activity_area.id'>
                          {{ activity_area.text | truncate(50) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4">
                      <label for="phone_number" class="col-form-label">Numéro de téléphone <span
                        class='icon-asterisk-solid'></span></label>
                    </div>
                    <div class="col-sm-8">
                      <input type="number" class="form-control" id="phone_number"
                             placeholder="Entrez votre numéro de téléphone"
                             onfocus="this.placeholder=''"
                             onblur="this.placeholder='Entrez votre numéro de téléphone'"
                             v-model="phone_number"
                             :class="[{'form-control':true, 'is-invalid' : !validPhoneNumber(phone_number) && blur_phone_number},{'form-control':true, 'is-valid' : validPhoneNumber(phone_number) && blur_phone_number}]"
                             v-on:blur="blur_phone_number = true"/>
                      <div class="invalid-feedback">
                        {{ error_phone_number }}
                      </div>
                      <div class="valid-feedback">
                        Numéro de téléphone valide.
                      </div>
                    </div>
                  </div>
                  <div class='form-group row' v-if="type_person === 'legal'">
                    <label for='job' class='col-sm-4 col-form-label'>Professionnel <span
                      class='icon-asterisk-solid'></span></label>
                    <div class='col-sm-8'>
                      <select class='custom-select mb-2 mr-sm-2 mb-sm-0'
                              id='is_professional'
                              name='is_professional'
                              v-model='is_professional'
                      >
                        <option value='0'>Non</option>
                        <option value='1'>Oui</option>
                      </select>
                    </div>
                  </div>
                  <div style="margin-top: 15px;">
                    <br />
                  </div>
                  <div v-if="type_person === 'legal'">
                    <div class='form-group row'>
                      <label for='address' class='col-sm-4 col-form-label'>Adresse<span
                        class='icon-asterisk-solid'></span></label>
                      <div class='col-sm-8'>
                        <input type='text' class='form-control' id='address'
                               placeholder='Entrez votre adresse'
                               onfocus="this.placeholder=''"
                               onblur="this.placeholder='Entrez votre adresse'" v-model='address'
                               :class="[{'form-control':true, 'is-invalid' : !validAddress(address) && blur_address},{'form-control':true, 'is-valid' : validAddress(address) && blur_address}]"
                               v-on:blur='blur_address = true'/>
                        <div class='invalid-feedback'>
                          {{ error_address }}
                        </div>
                        <div class='valid-feedback'>
                          Adresse valide.
                        </div>
                      </div>
                    </div>

                    <div class='form-group row'>
                      <label for='address_comp' class='col-sm-4 col-form-label'>Complément
                        d'adresse</label>
                      <div class='col-sm-8'>
                        <input type='text' class='form-control' id='address_comp'
                               placeholder="Entrez votre complément d'adresse"
                               onfocus="this.placeholder=''"
                               onblur="this.placeholder='Entrez votre complément d\'adresse'"
                               v-model='address_comp'
                               :class="[{'form-control':true, 'is-invalid' : !validAddressComp(address_comp) && blur_address_comp},{'form-control':true, 'is-valid' : validAddressComp(address_comp) && blur_address_comp}]"
                               v-on:blur='blur_address_comp = true'/>
                        <div class='invalid-feedback'>
                          {{ error_address_comp }}
                        </div>
                        <div class='valid-feedback'>
                          Complément d'adresse valide.
                        </div>
                      </div>
                    </div>

                    <div class='form-group row'>
                      <div class='col-sm-4'>
                        <label for='postal_code' class='col-form-label'>Code postal <span
                          class='icon-asterisk-solid'></span></label>
                      </div>
                      <div class='col-sm-8'>
                        <input type='number' class='form-control' id='postal_code'
                               placeholder='Entrez votre code postal'
                               onfocus="this.placeholder=''"
                               onblur="this.placeholder='Entrez votre code postal'"
                               v-model='postal_code'
                               :class="[{'form-control':true, 'is-invalid' : !validPostalCode(postal_code) && blur_postal_code},{'form-control':true, 'is-valid' : validPostalCode(postal_code) && blur_postal_code}]"
                               v-on:blur='blur_postal_code = true'/>
                        <div class='invalid-feedback'>
                          {{ error_postal_code }}
                        </div>
                        <div class='valid-feedback'>
                          Code postal valide.
                        </div>
                      </div>
                    </div>
                    <div class='form-group row'>
                      <div class='col-sm-4'>
                        <label for='city' class='col-form-label'>Ville <span
                          class='icon-asterisk-solid'></span></label>
                      </div>
                      <div class='col-sm-8'>
                        <input type='text' class='form-control' id='city'
                               placeholder='Entrez votre ville'
                               onfocus="this.placeholder=''"
                               onblur="this.placeholder='Entrez votre ville'" v-model='city'
                               :class="[{'form-control':true, 'is-invalid' : !validCity(city) && blur_city},{'form-control':true, 'is-valid' : validCity(city) && blur_city}]"
                               v-on:blur='blur_city = true'/>
                        <div class='invalid-feedback'>
                          {{ error_city }}
                        </div>
                        <div class='valid-feedback'>
                          Ville valide.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: 15px;">
                    <br />
                  </div>
                </template>

                <template v-if="type_person === 'natural'">
                </template>
                <template v-if="type_person === 'legal'">
                  <h5>Représentant légal</h5>
                </template>
                <div class='form-group row'>
                  <label for='natural_type_person_title' class='col-sm-4 col-form-label'>
                    Civilité <span class='icon-asterisk-solid'></span>
                  </label>
                  <div class='col-sm-8'>
                    <select class='custom-select mb-2 mr-sm-2 mb-sm-0'
                            id='natural_type_person_title' name='natural_type_person_title'
                            v-model='natural_type_person_title'>
                      <option value='1' selected>Monsieur</option>
                      <option value='2'>Madame</option>
                    </select>
                  </div>
                </div>
                <div class='form-group row'>
                  <label for='last_name' class='col-sm-4 col-form-label'>
                    Nom
                    <span class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8'>
                    <input type='text' id='last_name' class='form-control' required
                           placeholder='Nom' onfocus="this.placeholder=''"
                           onblur="this.placeholder='Nom'" v-model='last_name'
                           :class="[{'form-control':true, 'is-invalid' : !validLastName(last_name) && blur_last_name},{'form-control':true, 'is-valid' : validLastName(last_name) && blur_last_name}]"
                           v-on:blur='blur_last_name = true'/>
                    <div class='invalid-feedback'>
                      {{ error_last_name }}
                    </div>
                    <div class='valid-feedback'>
                      Nom valide.
                    </div>
                  </div>
                </div>
                <div class='form-group row'>
                  <label for='first_name' class='col-sm-4 col-form-label'>
                    Prénom <span class='icon-asterisk-solid'></span>
                  </label>
                  <div class='col-sm-8'>
                    <input type='text' id='first_name' class='form-control' required
                           placeholder='Prénom' onfocus="this.placeholder=''"
                           onblur="this.placeholder='Prénom'" v-model='first_name'
                           :class="[{'form-control':true, 'is-invalid' : !validFirstName(first_name) && blur_first_name},{'form-control':true, 'is-valid' : validFirstName(first_name) && blur_first_name}]"
                           v-on:blur='blur_first_name = true'/>
                    <div class='invalid-feedback'>
                      {{ error_first_name }}
                    </div>
                    <div class='valid-feedback'>
                      Prénom valide.
                    </div>
                  </div>
                </div>

                <div class='form-group row'>
                <label for='nationality' class='col-sm-4 col-form-label'>Nationalité <span
                  class='icon-asterisk-solid'></span></label>
                <div class='col-sm-8'>
                  <select class='custom-select mb-2 mr-sm-2 mb-sm-0'
                          id='nationality' name='nationality'
                          v-model='nationality' key="kNationality">
                    <option v-for="item in this.nationalityData" :value="item.value" :key="'k'+item.value">{{item.label}}</option>
                  </select>
                </div>
              </div>



                <div class='form-group row'>
                  <label for='birth_date' class='col-sm-4 col-form-label'>Date de naissance <span
                    class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8'>
                    <input type='text' class='form-control' id='birth_date'
                           placeholder='Entrez votre date de naissance'
                           onfocus="this.placeholder='__/__/____'"
                           onblur="this.placeholder='Entrez votre date de naissance'" v-model='birth_date'
                           :class="[{'form-control':true, 'is-invalid' : !validBirthDate(birth_date) && blur_birth_date},{'form-control':true, 'is-valid' : validBirthDate(birth_date) && blur_birth_date}]"
                           v-on:blur='blur_birth_date = true'/>
                    <div class='invalid-feedback'>
                      {{ error_birth_date }}
                    </div>
                    <div class='valid-feedback'>
                      Date de naissance valide.
                    </div>
                  </div>
                </div>
                <div class='form-group row'>
                  <label for='birth_place' class='col-sm-4 col-form-label'>Lieu de naissance <span
                    class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8'>
                    <input type='text' class='form-control' id='birth_place'
                           placeholder='Entrez votre lieu de naissance'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre lieu de naissance'" v-model='birth_place'
                           :class="[{'form-control':true, 'is-invalid' : !validBirthPlace(birth_place) && blur_birth_place},{'form-control':true, 'is-valid' : validBirthPlace(birth_place) && blur_birth_place}]"
                           v-on:blur='blur_birth_place = true'/>
                    <div class='invalid-feedback'>
                      {{ error_birth_place }}
                    </div>
                    <div class='valid-feedback'>
                      Lieu de naissance valide.
                    </div>
                  </div>
                </div>

                <div style="margin-top: 15px;">
                  <br />
                </div>
                <template v-if="type_person === 'natural'">
                  <div class='form-group row'>
                    <label for='job' class='col-sm-4 col-form-label'>Profession <span
                      class='icon-asterisk-solid'></span></label>
                    <div class='col-sm-8'>
                      <input type='text' class='form-control' id='job'
                             placeholder='Entrez votre profession'
                             onfocus="this.placeholder=''"
                             onblur="this.placeholder='Entrez votre profession'" v-model='job'
                             :class="[{'form-control':true, 'is-invalid' : !validJob(job) && blur_job},{'form-control':true, 'is-valid' : validJob(job) && blur_job}]"
                             v-on:blur='blur_job = true'/>
                      <div class='invalid-feedback'>
                        {{ error_job }}
                      </div>
                      <div class='valid-feedback'>
                        Profession valide.
                      </div>
                    </div>
                  </div>
                </template>

                <div class='form-group row' v-if="type_person === 'natural'">
                  <label for='job' class='col-sm-4 col-form-label'>Professionnel <span
                    class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8'>
                    <select class='custom-select mb-2 mr-sm-2 mb-sm-0'
                            id='is_professional'
                            name='is_professional'
                            v-model='is_professional'
                    >
                      <option value='0'>Non</option>
                      <option value='1'>Oui</option>
                    </select>
                  </div>
                </div>
                <div v-if="type_person === 'natural'">
                <div style="margin-top: 15px;">
                  <br />
                </div>
                <div class='form-group row'>
                  <label for='address' class='col-sm-4 col-form-label'>Adresse <span
                    class='icon-asterisk-solid'></span></label>
                  <div class='col-sm-8'>
                    <input type='text' class='form-control' id='address'
                           placeholder='Entrez votre adresse'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre adresse'" v-model='address'
                           :class="[{'form-control':true, 'is-invalid' : !validAddress(address) && blur_address},{'form-control':true, 'is-valid' : validAddress(address) && blur_address}]"
                           v-on:blur='blur_address = true'/>
                    <div class='invalid-feedback'>
                      {{ error_address }}
                    </div>
                    <div class='valid-feedback'>
                      Adresse valide.
                    </div>
                  </div>
                </div>

                <div class='form-group row'>
                  <label for='address_comp' class='col-sm-4 col-form-label'>Complément
                    d'adresse</label>
                  <div class='col-sm-8'>
                    <input type='text' class='form-control' id='address_comp'
                           placeholder="Entrez votre complément d'adresse"
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre complément d\'adresse'"
                           v-model='address_comp'
                           :class="[{'form-control':true, 'is-invalid' : !validAddressComp(address_comp) && blur_address_comp},{'form-control':true, 'is-valid' : validAddressComp(address_comp) && blur_address_comp}]"
                           v-on:blur='blur_address_comp = true'/>
                    <div class='invalid-feedback'>
                      {{ error_address_comp }}
                    </div>
                    <div class='valid-feedback'>
                      Complément d'adresse valide.
                    </div>
                  </div>
                </div>

                <div class='form-group row'>
                  <div class='col-sm-4'>
                    <label for='postal_code' class='col-form-label'>Code postal <span
                      class='icon-asterisk-solid'></span></label>
                  </div>
                  <div class='col-sm-8'>
                    <input type='number' class='form-control' id='postal_code'
                           placeholder='Entrez votre code postal'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre code postal'"
                           v-model='postal_code'
                           :class="[{'form-control':true, 'is-invalid' : !validPostalCode(postal_code) && blur_postal_code},{'form-control':true, 'is-valid' : validPostalCode(postal_code) && blur_postal_code}]"
                           v-on:blur='blur_postal_code = true'/>
                    <div class='invalid-feedback'>
                      {{ error_postal_code }}
                    </div>
                    <div class='valid-feedback'>
                      Code postal valide.
                    </div>
                  </div>
                </div>

                <div class='form-group row'>
                  <div class='col-sm-4'>
                    <label for='city' class='col-form-label'>Ville <span
                      class='icon-asterisk-solid'></span></label>
                  </div>
                  <div class='col-sm-8'>
                    <input type='text' class='form-control' id='city'
                           placeholder='Entrez votre ville'
                           onfocus="this.placeholder=''"
                           onblur="this.placeholder='Entrez votre ville'" v-model='city'
                           :class="[{'form-control':true, 'is-invalid' : !validCity(city) && blur_city},{'form-control':true, 'is-valid' : validCity(city) && blur_city}]"
                           v-on:blur='blur_city = true'/>
                    <div class='invalid-feedback'>
                      {{ error_city }}
                    </div>
                    <div class='valid-feedback'>
                      Ville valide.
                    </div>
                  </div>
                </div>
                </div>



                <button class='btn btn-lg btn-primary btn-block text-uppercase' type='submit'>
                  <span class='icon-signin'></span> S'inscrire
                </button>
              </form>
            </div>
            <div class='container'>
              <div class='row' style='padding: 10px;'>
                <router-link :to="{ name: 'login' }" class='col-sm-6 offset-sm-3'
                             style='text-align: center'> Vous possédez déjà un compte ? Identifiez-vous
                </router-link>
              </div>
              <div id='loader-container'>
                <PulseLoader :loading='loading' :color='color' :size='size'></PulseLoader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'register',
  components: {
    PulseLoader
  },
  filters: {
    // Filter definitions
    truncate(text, stop, clamp) {
      return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
    }
  },
  mounted() {
    this.$store.dispatch('postApi', {
      'controller': 'PCActivityArea',
      'action': 'getAll',
      'post': {}
    })
      .then(response => {
        this.activity_area_list = response.data
      })
  },
  computed: {
    valid: function () {
      if (this.type_person == 'legal') {
        return this.valid_password && this.valid_password_confirmation && this.valid_email && this.valid_address && this.valid_address_comp
          && this.valid_first_name && this.valid_last_name && this.valid_postal_code && this.valid_city && this.valid_company_name && this.valid_siret && this.valid_phone_number
      } else {
        return this.valid_password && this.valid_password_confirmation && this.valid_email && this.valid_address && this.valid_address_comp
          && this.valid_first_name && this.valid_last_name && this.valid_postal_code && this.valid_city && this.valid_job && this.valid_birth_place && this.valid_birth_date
      }
    }
  },
  data: function () {
    return {
      nationalityData:[{"value":"FR","label":"FR"},{"value":"AF","label":"AF"},{"value":"AL","label":"AL"},{"value":"DZ","label":"DZ"},{"value":"AS","label":"AS"},{"value":"AD","label":"AD"},{"value":"AO","label":"AO"},{"value":"AI","label":"AI"},{"value":"AQ","label":"AQ"},{"value":"AG","label":"AG"},{"value":"AR","label":"AR"},{"value":"AM","label":"AM"},{"value":"AW","label":"AW"},{"value":"AU","label":"AU"},{"value":"AT","label":"AT"},{"value":"AZ","label":"AZ"},{"value":"BS","label":"BS"},{"value":"BH","label":"BH"},{"value":"BD","label":"BD"},{"value":"BB","label":"BB"},{"value":"BY","label":"BY"},{"value":"BE","label":"BE"},{"value":"BZ","label":"BZ"},{"value":"BJ","label":"BJ"},{"value":"BM","label":"BM"},{"value":"BT","label":"BT"},{"value":"BO","label":"BO"},{"value":"BA","label":"BA"},{"value":"BW","label":"BW"},{"value":"BV","label":"BV"},{"value":"BR","label":"BR"},{"value":"IO","label":"IO"},{"value":"BN","label":"BN"},{"value":"BG","label":"BG"},{"value":"BF","label":"BF"},{"value":"BI","label":"BI"},{"value":"KH","label":"KH"},{"value":"CM","label":"CM"},{"value":"CA","label":"CA"},{"value":"CV","label":"CV"},{"value":"KY","label":"KY"},{"value":"CF","label":"CF"},{"value":"TD","label":"TD"},{"value":"CL","label":"CL"},{"value":"CN","label":"CN"},{"value":"CX","label":"CX"},{"value":"CC","label":"CC"},{"value":"CO","label":"CO"},{"value":"KM","label":"KM"},{"value":"CG","label":"CG"},{"value":"CK","label":"CK"},{"value":"CR","label":"CR"},{"value":"HR","label":"HR"},{"value":"CU","label":"CU"},{"value":"CY","label":"CY"},{"value":"CZ","label":"CZ"},{"value":"DK","label":"DK"},{"value":"DJ","label":"DJ"},{"value":"DM","label":"DM"},{"value":"DO","label":"DO"},{"value":"TP","label":"TP"},{"value":"EC","label":"EC"},{"value":"EG","label":"EG"},{"value":"SV","label":"SV"},{"value":"GQ","label":"GQ"},{"value":"ER","label":"ER"},{"value":"EE","label":"EE"},{"value":"ET","label":"ET"},{"value":"FK","label":"FK"},{"value":"FO","label":"FO"},{"value":"FJ","label":"FJ"},{"value":"FI","label":"FI"},{"value":"GF","label":"GF"},{"value":"PF","label":"PF"},{"value":"TF","label":"TF"},{"value":"GA","label":"GA"},{"value":"GM","label":"GM"},{"value":"GE","label":"GE"},{"value":"DE","label":"DE"},{"value":"GH","label":"GH"},{"value":"GI","label":"GI"},{"value":"GR","label":"GR"},{"value":"GL","label":"GL"},{"value":"GD","label":"GD"},{"value":"GP","label":"GP"},{"value":"GU","label":"GU"},{"value":"GT","label":"GT"},{"value":"GG","label":"GG"},{"value":"GN","label":"GN"},{"value":"GW","label":"GW"},{"value":"GY","label":"GY"},{"value":"HT","label":"HT"},{"value":"HM","label":"HM"},{"value":"VA","label":"VA"},{"value":"HN","label":"HN"},{"value":"HK","label":"HK"},{"value":"HU","label":"HU"},{"value":"IS","label":"IS"},{"value":"IN","label":"IN"},{"value":"ID","label":"ID"},{"value":"IR","label":"IR"},{"value":"IQ","label":"IQ"},{"value":"IE","label":"IE"},{"value":"IM","label":"IM"},{"value":"IL","label":"IL"},{"value":"IT","label":"IT"},{"value":"CI","label":"CI"},{"value":"JM","label":"JM"},{"value":"JP","label":"JP"},{"value":"JE","label":"JE"},{"value":"JO","label":"JO"},{"value":"KZ","label":"KZ"},{"value":"KE","label":"KE"},{"value":"KI","label":"KI"},{"value":"KW","label":"KW"},{"value":"KG","label":"KG"},{"value":"LA","label":"LA"},{"value":"LV","label":"LV"},{"value":"LB","label":"LB"},{"value":"LS","label":"LS"},{"value":"LR","label":"LR"},{"value":"LY","label":"LY"},{"value":"LI","label":"LI"},{"value":"LT","label":"LT"},{"value":"LU","label":"LU"},{"value":"MO","label":"MO"},{"value":"MK","label":"MK"},{"value":"MG","label":"MG"},{"value":"MW","label":"MW"},{"value":"MY","label":"MY"},{"value":"MV","label":"MV"},{"value":"ML","label":"ML"},{"value":"MT","label":"MT"},{"value":"MH","label":"MH"},{"value":"MQ","label":"MQ"},{"value":"MR","label":"MR"},{"value":"MU","label":"MU"},{"value":"YT","label":"YT"},{"value":"MX","label":"MX"},{"value":"FM","label":"FM"},{"value":"MD","label":"MD"},{"value":"MC","label":"MC"},{"value":"MN","label":"MN"},{"value":"ME","label":"ME"},{"value":"MS","label":"MS"},{"value":"MA","label":"MA"},{"value":"MZ","label":"MZ"},{"value":"MM","label":"MM"},{"value":"NA","label":"NA"},{"value":"NR","label":"NR"},{"value":"NP","label":"NP"},{"value":"NL","label":"NL"},{"value":"AN","label":"AN"},{"value":"NC","label":"NC"},{"value":"NZ","label":"NZ"},{"value":"NI","label":"NI"},{"value":"NE","label":"NE"},{"value":"NG","label":"NG"},{"value":"NU","label":"NU"},{"value":"NF","label":"NF"},{"value":"KP","label":"KP"},{"value":"GB","label":"GB"},{"value":"MP","label":"MP"},{"value":"NO","label":"NO"},{"value":"OM","label":"OM"},{"value":"PK","label":"PK"},{"value":"PW","label":"PW"},{"value":"PS","label":"PS"},{"value":"PA","label":"PA"},{"value":"PG","label":"PG"},{"value":"PY","label":"PY"},{"value":"PE","label":"PE"},{"value":"PH","label":"PH"},{"value":"PN","label":"PN"},{"value":"PL","label":"PL"},{"value":"PT","label":"PT"},{"value":"PR","label":"PR"},{"value":"QA","label":"QA"},{"value":"RE","label":"RE"},{"value":"RO","label":"RO"},{"value":"RU","label":"RU"},{"value":"RW","label":"RW"},{"value":"SH","label":"SH"},{"value":"KN","label":"KN"},{"value":"LC","label":"LC"},{"value":"PM","label":"PM"},{"value":"VC","label":"VC"},{"value":"WS","label":"WS"},{"value":"SM","label":"SM"},{"value":"ST","label":"ST"},{"value":"SA","label":"SA"},{"value":"SN","label":"SN"},{"value":"RS","label":"RS"},{"value":"SC","label":"SC"},{"value":"SL","label":"SL"},{"value":"SG","label":"SG"},{"value":"SK","label":"SK"},{"value":"SI","label":"SI"},{"value":"SB","label":"SB"},{"value":"SO","label":"SO"},{"value":"ZA","label":"ZA"},{"value":"GS","label":"GS"},{"value":"KR","label":"KR"},{"value":"SS","label":"SS"},{"value":"ES","label":"ES"},{"value":"LK","label":"LK"},{"value":"SD","label":"SD"},{"value":"SR","label":"SR"},{"value":"SJ","label":"SJ"},{"value":"SZ","label":"SZ"},{"value":"SE","label":"SE"},{"value":"CH","label":"CH"},{"value":"SY","label":"SY"},{"value":"TJ","label":"TJ"},{"value":"TZ","label":"TZ"},{"value":"TH","label":"TH"},{"value":"CD","label":"CD"},{"value":"TL","label":"TL"},{"value":"TG","label":"TG"},{"value":"TK","label":"TK"},{"value":"TO","label":"TO"},{"value":"TT","label":"TT"},{"value":"TN","label":"TN"},{"value":"TR","label":"TR"},{"value":"TM","label":"TM"},{"value":"TC","label":"TC"},{"value":"TV","label":"TV"},{"value":"UG","label":"UG"},{"value":"UA","label":"UA"},{"value":"AE","label":"AE"},{"value":"GB","label":"GB"},{"value":"US","label":"US"},{"value":"UM","label":"UM"},{"value":"UY","label":"UY"},{"value":"UZ","label":"UZ"},{"value":"VU","label":"VU"},{"value":"VE","label":"VE"},{"value":"VN","label":"VN"},{"value":"VG","label":"VG"},{"value":"VI","label":"VI"},{"value":"WF","label":"WF"},{"value":"EH","label":"EH"},{"value":"YE","label":"YE"},{"value":"YU","label":"YU"},{"value":"ZM","label":"ZM"},{"value":"ZW","label":"ZW"}],
      selected_activity_area: 1,
      activity_area_list: [],
      user_manual_link: 'src/public/doc/Credicys - documentation utilisateur non connecte.pdf?' + Date.now(),
      //PulseLoader props
      loading: false,
      color: '#d93752',
      size: '1em',
      // Form props
      type_person: 'legal',
      passwordFieldType: 'password',

      password: '',
      valid_password: false,
      error_password: '',
      blur_password: false,

      password_confirmation: '',
      valid_password_confirmation: false,
      error_password_confirmation: '',
      blur_password_confirmation: false,

      email: '',
      existing_email: '',
      valid_email: false,
      error_email: '',
      blur_email: false,

      last_name: '',
      valid_last_name: false,
      error_last_name: '',
      blur_last_name: false,

      first_name: '',
      valid_first_name: false,
      error_first_name: '',
      blur_first_name: false,

      company_name: '',
      valid_company_name: false,
      error_company_name: '',
      blur_company_name: false,

      job: '',
      valid_job: false,
      error_job: '',
      blur_job: false,

      birth_place: '',
      valid_birth_place: false,
      error_birth_place: '',
      blur_birth_place: false,

      nationality: 'FR',


      birth_date: '',
      valid_birth_date: false,
      error_birth_date: '',
      blur_birth_date: false,

      siret: '',
      valid_siret: false,
      error_siret: '',
      blur_siret: false,

      phone_number: '',
      valid_phone_number: false,
      error_phone_number: '',
      blur_phone_number: false,

      natural_type_person_title: 1,
      legal_type_person_title: 3,

      address: '',
      valid_address: false,
      error_address: '',
      blur_address: false,

      address_comp: '',
      valid_address_comp: false,
      error_address_comp: '',
      blur_address_comp: false,

      postal_code: '',
      valid_postal_code: false,
      error_postal_code: '',
      blur_postal_code: false,

      city: '',
      valid_city: false,
      error_city: '',
      blur_city: false,
      is_professional: 1
    }
  }
  ,
  methods: {
    create: function () {
      this.loading = true

      this.$store.dispatch('postApi', {
        'controller': 'PCAuth',
        'action': 'createAuth',
        'post': {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          type_person: this.type_person,
          company_name: this.company_name,
          siret: this.siret,
          phone_number: this.phone_number,
          first_name: this.first_name,
          last_name: this.last_name,
          address: this.address,
          address_comp: this.address_comp,
          postal_code: this.postal_code,
          city: this.city,
          natural_type_person_title: this.natural_type_person_title,
          legal_type_person_title: this.legal_type_person_title,
          activity_area: this.selected_activity_area,
          job: this.job,
          birth_place: this.birth_place,
          birth_date: this.birth_date,
          is_professional: this.is_professional,
          nationality: this.nationality
        }
      })
        .then(response => {
          this.loading = false
          if (response.data.error === 'mail_exist') {
            this.existing_email = this.email
            this.valid_email = false
          } else {
            this.$router.push({name: 'register-success'})
          }
        })
      this.loading = false
    },
    showPasswords: function () {
      this.passwordFieldType = 'text'
    },
    hidePasswords: function () {
      this.passwordFieldType = 'password'
    },
    validate: function () {
      this.blur_email = true
      this.blur_password = true
      this.blur_password_confirmation = true
      this.blur_company_name = true
      this.blur_siret = true
      this.blur_phone_number = true
      this.blur_first_name = true
      this.blur_last_name = true
      this.blur_address = true
      this.blur_address_comp = true
      this.blur_postal_code = true
      this.blur_city = true
      this.blur_job = true;
      this.blur_birth_place = true;
      this.blur_birth_date = true;

      if (this.validEmail(this.email)) {
        this.valid_email = true
      } else {
        this.valid_email = false
      }
      if (this.validPassword(this.password)) {
        this.valid_password = true
      } else {
        this.valid_password = false
      }
      if (this.validPasswordConfirmation(this.password_confirmation)) {
        this.valid_password_confirmation = true
      } else {
        this.valid_password_confirmation = false
      }
      if (this.validFirstName(this.first_name)) {
        this.valid_first_name = true
      } else {
        this.valid_first_name = false
      }

      if (this.validLastName(this.last_name)) {
        this.valid_last_name = true
      } else {
        this.valid_last_name = false
      }

      if (this.type_person === 'legal') {
        if (this.validPhoneNumber(this.phone_number)) {
          this.valid_phone_number = true
        } else {
          this.valid_phone_number = false
        }
        if (this.validCompanyName(this.company_name)) {
          this.valid_company_name = true
        } else {
          this.valid_company_name = false
        }
        if (this.validSiret(this.siret)) {
          this.valid_siret = true
        } else {
          this.valid_siret = false
        }
      }

      if (this.type_person === 'natural') {
        if (this.validJob(this.job)) {
          this.valid_job = true
        } else {
          this.valid_job = false
        }

      }

      if (this.validBirthPlace(this.birth_place)) {
        this.valid_birth_place = true
      } else {
        this.valid_birth_place = false
      }
      if (this.validBirthDate(this.birth_date)) {
        this.valid_birth_date = true
      } else {
        this.valid_birth_date = false
      }

      if (this.validAddress(this.address)) {
        this.valid_address = true
      } else {
        this.valid_address = false
      }
      if (this.validAddressComp(this.address_comp)) {
        this.valid_address_comp = true
      } else {
        this.valid_address_comp = false
      }
      if (this.validPostalCode(this.postal_code)) {
        this.valid_postal_code = true
      } else {
        this.valid_postal_code = false
      }
      if (this.validCity(this.city)) {
        this.valid_city = true
      } else {
        this.valid_city = false
      }

    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (!re.test(email.toLowerCase())) {
        this.error_email = 'Merci de renseigner un email valide.'
        return false
      }

      if (this.existing_email != '' && email === this.existing_email) {
        this.error_email = 'L\'email ' + this.existing_email + ' est déjà utilisé.'
        return false
      }

      return true
    },
    validPhoneNumber: function (phone_number) {
      var re = /^((\+)33|0)[1-9](\d{2}){4}$/

      if (phone_number.trim().length == 0) {
        this.error_phone_number = 'Merci de renseigner votre téléphone.'
        return false
      }

      if (!re.test(phone_number)) {
        this.error_phone_number = 'Merci de renseigner un téléphone valide.'
        return false
      }
      return true
    },
    validPassword: function (password) {
      if (this.password.trim().length == 0) {
        this.error_password = 'Merci de renseigner un mot de passe.'
        return false
      }
      if (this.password.trim().length < 8) {
        this.error_password = 'Votre mot de passe doit contenir au moins 8 caractères.'
        return false
      }
      return true
    },
    validPasswordConfirmation: function (password_confirmation) {
      if (this.password.trim().length == 0) {
        this.error_password_confirmation = 'Merci de renseigner un mot de passe.'
        return false
      } else if (this.password_confirmation.trim().length == 0) {
        this.error_password_confirmation = 'Merci de confirmer votre mot de passe.'
        return false
      } else if (password_confirmation !== this.password) {
        this.error_password_confirmation = 'Les mots de passe ne sont pas identiques.'
        return false
      }
      return true
    },
    validFirstName: function (first_name) {
      if (first_name.trim().length == 0) {
        this.error_first_name = 'Merci de renseigner votre prénom.'
        return false
      }

      return true
    },
    validLastName: function (last_name) {
      if (last_name.trim().length == 0) {
        this.error_last_name = 'Merci de renseigner votre nom.'
        return false
      }

      return true
    },
    validCompanyName: function (company_name) {
      if (company_name.trim().length == 0) {
        this.error_company_name = 'Merci de renseigner le nom de votre société.'
        return false
      }

      return true
    },
    validSiret: function (siret) {
      if (siret.trim().length == 0) {
        this.error_siret = 'Merci de renseigner votre SIRET.'
        return false
      }

      if (siret.trim().length != 14) {
        this.error_siret = 'Votre SIRET doit contenir 14 chiffres.'
        return false
      }

      return true
    },
    validAddress: function (address) {
      if (address.trim().length == 0) {
        this.error_address = 'Merci de renseigner votre adresse.'
        return false
      }

      return true
    },
    validAddressComp: function (address_comp) {
      return true
    },
    validPostalCode: function (postal_code) {
      if (postal_code.trim().length == 0) {
        this.error_postal_code = 'Merci de renseigner votre code postal.'
        return false
      }

      if (postal_code.trim().length != 5) {
        this.error_postal_code = 'Votre code postal doit contenir exactement 5 chiffres.'
        return false
      }

      return true
    },
    validCity: function (city) {
      if (city.trim().length == 0) {
        this.error_city = 'Merci de renseigner votre ville.'
        return false
      }

      return true
    },
    validJob: function (job) {
      if (job.trim().length == 0) {
        this.error_job = 'Merci de renseigner votre profession.'
        return false
      }

      if (job.trim().length > 150) {
        this.error_job = 'Merci de ne pas utiliser pus de 150 caractères.'
        return false
      }

      return true;
    },
    validBirthPlace: function (birth_place) {
      if (birth_place.trim().length == 0) {
        this.error_birth_place = 'Merci de renseigner votre lieu de naissance.'
        return false
      }

      if (birth_place.trim().length > 150) {
        this.error_birth_place = 'Merci de ne pas utiliser pus de 150 caractères.'
        return false
      }

      return true;
    },
    validBirthDate: function (birth_date) {
      var re = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/

      if (birth_date.length == 0) {
        this.error_birth_date = 'Merci de renseigner votre date de naissance ex (01/01/1960).'
        return false
      }

      if (!re.test(birth_date)) {
        this.error_birth_date = 'Merci de renseigner votre date de naissance ex (01/01/1960).'
        return false
      }
      return true
    },
    onChangeTypePerson: function () {

      if (this.type_person == 'natural') {
        this.is_professional = 0;
      } else {
        this.is_professional = 1;
      }
    },
    register: function () {
      this.validate()
      if (this.valid) {
        this.create()
      }
    },
  }
}
</script>

<style scoped>
#card-register {
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue